import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { InternalTicket, TicketListObject } from '../Types';

interface TicketReduxState {
  foundTickets: TicketListObject;
  ticketsToBePrinted?: InternalTicket[];
  refreshTickets: boolean;
}

const initialState: TicketReduxState = {
  foundTickets: { OpenDataTickets: [], isImport: false },
  ticketsToBePrinted: [],
  refreshTickets: false
};

export const ticketsSlice = createSlice({
  name: 'tickets',
  initialState: { ...initialState },
  reducers: {
    setFoundTickets: (state, action: PayloadAction<TicketListObject>) => {
      state.foundTickets = action.payload;
    },
    setTicketsToBePrinted: (state, action) => {
      state.ticketsToBePrinted = action.payload;
    },
    setRefreshTickets: (state, action: PayloadAction<boolean>) => {
      state.refreshTickets = action.payload;
    },
    clearTicketsSlice: () => {
      return initialState;
    }
  }
});

export const { setFoundTickets, setTicketsToBePrinted, setRefreshTickets, clearTicketsSlice } =
  ticketsSlice.actions;

export default ticketsSlice.reducer;
